import { Component, OnInit } from '@angular/core';
import { Language } from '../models/language';
import { LanguageService } from './language.service';

@Component({
    selector: 'language-bar',
    templateUrl: './language.component.html'
})
export class LanguageComponent implements OnInit {
    public selectedLang: string;
    public supportedLangs: Language[] = [];
    private _primaryLangValue: string;

    constructor(private languageService: LanguageService) {
    }

    ngOnInit() {
        this.languageService.getSupportedLanguageList().subscribe(res => {
            res.forEach(obj => {
                if (obj.isPrimaryLanguage === true) {
                    this._primaryLangValue = obj.code;
                }
                this.supportedLangs.push({ id: obj.id, name: obj.name, code: obj.cultureName, value: obj.code, isPrimaryLanguage: obj.isPrimaryLanguage, cultureName: obj.cultureName });


            });

            if (!this.languageService.currentLang || this.languageService.currentLang == 'undefined') {
                this.selectLanguage(this._primaryLangValue, false);
            }
            else
                this.selectLanguage(this.languageService.currentLang, false);
        }
        );
    }

    selectLanguage(lang: string, isRefresh: boolean = true) {
        this.selectedLang = lang;
        this.languageService.use(this.selectedLang);

        if (isRefresh)
            location.reload();
    }
}
